<script>
import axios from 'axios';
import PasswordInput from '../inputs/PasswordInput';
import UserService from '@/services/UserService';
import PhonenumberService from '@/services/PhonenumberService';
import ResetPasswordService from '@/services/ResetPasswordService';
import FaxUserService from '@/services/FaxUserService';
import SupportUserService from '@/services/SupportUserService';
import TariffChangeService from '@/services/TariffChangeService';
import ButtonNormal from '../buttons/ButtonNormal';
import {SET_ACTIVE_USER_ID} from '@/store/mutation-types';
import Modal from '../shared/Modal';

import { authenticate, isLoggedIn } from '@/services/Authentication';
import { mapActions } from 'vuex';

export default {
    name: 'Login',
    components: { PasswordInput, ButtonNormal, Modal },
    data() {
        return {
            form: {
                server: '',
                loginId: '',
                password: '',
                rememberMe: false,
                hasError: false,
                errorMessage: '',
                errorServerMessage: '',
            },
            passwordResetForm: {
                subdomain: '',
                loginId: '',
                hasError: false,
                serverIncorrect: '',
                loginIdIncorrect: ''
            },
            passwordResetModal: {
                showForm: true,
            },
            userList: [],
            modalVisible: false
        };
    },
    methods: {
        ...mapActions(['getTarif']),
        onSubmit(evt) {
            const { server, loginId, password, rememberMe } = this.form;
            evt.preventDefault();
            authenticate(server, loginId, password, rememberMe)
                .then(result => {
                    if (result.authSuccess) {
                        this.form.hasError = false;
                        this.form.errorMessage = '';

                        UserService.getActiveUser().then(user => {
                            this.$store.commit(SET_ACTIVE_USER_ID, user.data.id);
                            UserService.getPhonenumbersForUser(
                                user.data.id
                            ).then((phonenumbers) => {
                                const promises = Promise.all(
                                    phonenumbers.data.map(phonenumber => {
                                        return PhonenumberService.getPhonenumber(
                                            phonenumber.phoneNumberId
                                        ).then(num => {
                                            return num.data.type === 'EXTERNAL';
                                        });
                                    })
                                );

                                promises.then(results => {
                                    if (results.includes(true)) {
                                        this.$router.replace('/');
                                    } else {
                                        this.$router.replace('/wizard/admin');
                                    }
                                });
                            });
                        });
                        this.getTarif(server);
                    } else {
                        this.form.errorServerMessage = '';
                        this.form.errorMessage = '';
                        this.form.hasError = true;
                        this.form.errorMessage = result.message || result.error.message;
                    }
                })
                .catch(error => {
                    this.form.errorServerMessage = '';
                    this.form.errorMessage = '';
                    this.form.hasError = true;
                    if (error.type === 'SERVER_NOT_FOUND') {
                        this.form.errorServerMessage = error.message;
                    } else {
                        this.form.errorMessage = error.message;
                    }
                });
        },
        onSubmitPasswordReset(evt) {
            evt.preventDefault();
            this.cleanResetPasswordFormErrorMessages();
            ResetPasswordService.resetPassword({
                subdomain: this.passwordResetForm.subdomain,
                loginId: this.passwordResetForm.loginId
            }
            )
            .then(response => {
                const cloudAddressCorrectAndExisting = response.status === 200 && response.data.success;
                if (cloudAddressCorrectAndExisting) {
                    this.cleanResetPasswordForm();
                    this.passwordResetModal.showForm = false;
                } else {
                    this.passwordResetForm.hasError = true;
                    const cloudAddressDoesNotExist = response.data.error.code === '401';
                    if (cloudAddressDoesNotExist) {
                        this.passwordResetForm.serverIncorrect = 'Server nicht bekannt';
                    }
                    const cloudAddressExistLoginIncorrect = response.data.error.code === '402';
                    if (cloudAddressExistLoginIncorrect) {
                        this.passwordResetForm.loginIdIncorrect = 'Login-ID darf nur Ziffern enthalten';
                    }
                }
            })
            .catch(err => {
                this.passwordResetForm.serverIncorrect = 'Server nicht bekannt';
            });
        },
        cleanResetPasswordForm() {
            this.passwordResetForm = {
                subdomain: '',
                loginId: '',
                hasError: false,
                serverIncorrect: '',
                loginIdIncorrect: ''
            };
        },
        cleanResetPasswordFormErrorMessages() {
            this.passwordResetForm.hasError = false;
            this.passwordResetForm.serverIncorrect = '';
            this.passwordResetForm.loginIdIncorrect = '';
        },
        showModal() {
            this.passwordResetModal.showForm = true;
            this.modalVisible = !this.modalVisible;
        },
        closeModal() {
            this.modalVisible = false;
            this.cleanResetPasswordForm();
        },
    }
};
</script>

<template>
    <div class="container-fluid">
        <div id="login" class="login-wrapper">
            <div class="login-image">
                 <img src="../../assets/login-team-image.jpg" alt="Login" />
            </div>
            <div class="login-form">
                <div class="login-form-title">
                    <h1>Willkommen <br/> bei STARFACE UP</h1>
                </div>
                <form @submit="onSubmit" class="form">
                    <div class="form-group">
                        <label for="login_id">Server</label>
                        <input type="text" name="server" id="server" class="form-control" v-bind:class="{ 'has-error': form.hasError }" v-model="form.server" required/>
                        <span class="placeholder">.starface-cloud.com</span>
                        <div class="error-message"  v-if="form.hasError">{{form.errorServerMessage}}</div>
                    </div>
                    <div class="form-group">
                        <label for="login_id">Login-ID</label>
                        <input type="text" name="loginId" id="login_id" class="form-control" v-bind:class="{ 'has-error': form.hasError }" v-model="form.loginId" placeholder="z.B.: 4972198199100" required/>
                    </div>
                    <div class="form-group">
                        <PasswordInput :label="'Passwort'" :has-error="form.hasError" v-model="form.password" />
                        <div class="error-message"  v-if="form.hasError">{{form.errorMessage}}</div>
                    </div>
                    <div  class="form-group form-check">
                        <input type="checkbox" id="remember_me" name="rememberMe" class="form-check-input" v-model="form.rememberMe">
                        <label for="remember_me" class="form-check-label">Zugangsdaten speichern</label>
                    </div>
                    <div class="form-submit">
                        <ButtonNormal buttonTitle="Einloggen" cssClass="btn btn-primary"/>
                    </div>

                </form>
                <div class="forgot-password" @click="showModal()">Passwort vergessen?</div>
            </div>
        </div>
        <Modal v-show="modalVisible" :isFooter="false" :isCross="true" :isRed="true"
               @close="closeModal" class="forgot-password-modal">
            <!-- MODAL FORM TEMPLATE -->
            <template slot="body" v-if="passwordResetModal.showForm"> 
                <div class="modal-form-template">
                    <div class="form-title">
                        <span>Passwort vergessen?</span>
                    </div>
                    <div class="form-description">
                        <span>Nenne uns bitte Deinen Servernamen und Deine Login-ID.</span>
                    </div>
                    <form @submit="onSubmitPasswordReset">
                        <div class="form-group">
                            <label for="forgot_password_server">Server</label>
                            <input type="text" name="forgot_password_server" id="forgot_password_server" 
                                class="form-control" 
                                v-bind:class="{ 'has-error': passwordResetForm.hasError }" 
                                v-model="passwordResetForm.subdomain"
                                required/>
                            <span class="placeholder">.starface-cloud.com</span>
                            <div class="error-message"  v-if="passwordResetForm.hasError">{{passwordResetForm.serverIncorrect}}</div>
                        </div>
                        <div class="form-group">
                            <label for="forgot_password_login_id">Login-ID</label>
                            <input type="text" name="loginId" id="forgot_password_login_id" class="form-control" v-bind:class="{ 'has-error': passwordResetForm.hasError }" v-model="passwordResetForm.loginId" placeholder="z.B.: 4972198199100" required/>
                            <div class="error-message"  v-if="passwordResetForm.hasError">{{passwordResetForm.loginIdIncorrect}}</div>
                        </div>
                        <div class="form-submit">
                            <ButtonNormal buttonTitle="Anfrage versenden" cssClass="btn btn-primary"/>
                        </div>
                    </form>
                </div>
            </template>
            <!-- MODAL NOTIFICATION TEMPLATE -->
            <template slot="body" v-else> 
                <div class="modal-notification-template">
                    <div class="notification-icon">
                        <img src="@/assets/starface_icons_png/96/orange/circle_checked.png" alt="Password reset icon"/>
                    </div>
                    <div class="notification-title">
                        <span>Deine Anfrage ist bei uns eingegangen!</span>
                    </div>
                    <div class="notification-description">
                        <span>Der Schutz Deiner Daten ist uns wichtig! Daher werden wir Deine Anfrage persönlich überprüfen und bearbeiten. Anschließend setzten wir uns persönlich mit Dir in Verbindung. Dies kann bis zu einem Werktag dauern.</span>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
@import '../../assets/scss/forms.scss';
@import '../../assets/scss/inputs.scss';

.login-wrapper {
    position: relative;
    display: grid;
    display: -ms-grid;
    height: 705px;
    grid-template-columns: 1fr 1fr;
    -ms-grid-columns: 1fr 1fr;
    .login-image {
        grid-column: 1;
        -ms-grid-column: 1;
        height: 100%;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .login-form {
        -ms-grid-column: 2;
        margin: 0 auto;
        padding-left: 75px;
        padding-right: 75px;
        width: 100%;
        color: $grey-dark;
        font-size: 18px;
        z-index: 1;
        background: #f9f9f9;

        &-title {
            text-align: left;
            h1 {
                color: $grey-dark;
                font-weight: 500;
                margin-top: 31px;
                margin-bottom: 20px;
            }
        }

        .form {
            .form-group {
                position: relative;
                margin-bottom: 32px;
                text-align: left;
                label {
                    display: inline-block;
                    color: #b8b8b8;
                    font-size: 14px;
                    margin-bottom: 10px;
                }
                &.form-check {
                    position: relative;
                    display: block;
                    text-align: left;
                    height: 24px;
                    .form-check-input {
                        position: absolute;
                        margin-left: -4px;
                    }
                    .form-check-label {
                        font-size: 18px;
                        letter-spacing: 0;
                        line-height: 24px;
                        color: $grey-dark;
                        margin-bottom: 0px;
                        padding-left: 24px;
                        &::before {
                            top: 6px;
                            left: 1px;
                        }
                        &::after {
                            top: 4px;
                        }
                    }
                }
                .form-control {
                    line-height: 24px;
                    text-align: left;
                    &:focus {
                        outline: none;
                    }

                    &.has-error {
                        border-color: #f54d00;
                    }
                }
                .error-message {
                    font-size: 18px;
                    font-weight: 600;
                    text-align: left;
                    margin-top: 5px;
                    margin-bottom: -21px;
                    color: #f54d00;
                }

                .form-group {
                    margin-bottom: 0;
                }

                .placeholder {
                    position: absolute;
                    top: 31px;
                    right: 0;
                    opacity: 0.5;
                }
            }
            .form-submit {
                text-align: center;
                margin-bottom: 8px;
                .btn {
                    display: inline-block;
                    width: 205px;
                }
            }
        }
        .forgot-password {
            color: $orange;
            cursor: pointer;
            text-decoration: underline;
            font-size: 16px;
            letter-spacing: 0;
            line-height: 22px;
            text-align: center;
        }
    }
}
.forgot-password-modal {
    /deep/ .modal{
        width: 538px;
        max-height: 550px;
        .modal-body {
            padding: 40px;

            .modal-form-template{
                padding-right: 40px;
                padding-left: 40px;
                padding-bottom: 20;
                .form-title{
                    font-size: 28px;
                    letter-spacing: 0;
                    line-height: 38px; 
                    padding-bottom: 24px;
                }
                .form-description {
                    font-size: 18px;
                    letter-spacing: 0;
                    line-height: 24px;
                    padding-bottom: 32px;
                }
                form {
                    .form-group{
                        position: relative;
                        margin-bottom: 32px;
                        text-align: left;
                        label {
                            display: inline-block;
                            color: #b8b8b8;
                            font-size: 14px;
                            margin-bottom: 10px;
                        }
                        .placeholder {
                            position: absolute;
                            top: 31px;
                            right: 0;
                            opacity: 0.5;
                        }
                        .error-message {
                            position: absolute;
                            font-size: 18px;
                            letter-spacing: 0;
                            line-height: 21px;
                            font-weight: 600;
                            text-align: left;
                            margin-top: 5px;
                            color: #f54d00;
                        }
                    }
                    .form-submit {
                        text-align: center;
                        padding-top: 14px;
                        .btn {
                            display: inline-block;
                            width: 205px;
                        }
                    }
                }   
            }

            .modal-notification-template {
                padding-bottom: 40px;
                .notification-icon {
                    text-align: center;
                    padding-bottom: 24px;
                }
                .notification-title {
                    font-size: 18px;
                    font-weight: bold;
                    letter-spacing: 0;
                    line-height: 24px;
                    text-align: center;
                    padding-bottom: 10px;
                }
                .notification-description {
                    font-size: 18px;
                    letter-spacing: 0;
                    line-height: 24px;
                    text-align: center;
                }
            }
        }
    }


}
</style>
